<!-- my order filter / -->
<div class="md:mt-6 z-[0]">
  <mat-accordion>
    @if (
      data?.reviewerStaticInfo?.reviewFormDialogData?.value.viewType ===
      'CENTER'
    ) {
      <mat-expansion-panel
        hideToggle
        disabled
        class="!bg-transparent !shadow-none"
        style="border-color: #f4f6f8 !important"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="w-full">
            <div
              class="w-full sticky top-0 flex flex-wrap md:flex-nowrap justify-between gap-[10px] py-[10px] text-[#162F4D] text-[16px] font-semibold border-b border-[#162f4d]"
            >
              <!-- Order Number -->
              <div class="flex-1 text-center md:text-left">
                {{ data?.orderTitles?.ORDER_NO }}
              </div>

              <!-- Order Date -->
              <div class="flex-1 text-center">
                {{ data?.orderTitles?.ORDER_DATE }}
              </div>

              <!-- Order Amount -->
              <div class="flex-1 text-center md:text-right">
                {{ data?.orderTitles?.ORDER_AMOUNT }}
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
    }

    @for (orderInfo of data?.renderableComponents; track $index) {
      <mat-expansion-panel
        [expanded]="orderInfo?.value?.expanded"
        class="!shadow-md border border-solid !mx-0 !mt-0 !mb-[15px] !bg-[#ffffff]"
        style="border-color: #f4f6f8 !important"
      >
        <mat-expansion-panel-header
          class="py-8 !bg-[#ffffff]"
          [collapsedHeight]="'54px'"
          [expandedHeight]="'54px'"
        >
          <mat-panel-title class="py-4">
            <div
              class="w-full sticky top-0 flex md:flex-nowrap flex-wrap gap-[20px] md:gap-[10px] py-[10px] text-[#162F4D] text-[16px] font-semibold border-b"
              style="border-bottom-color: #162f4d !important"
            >
              <!-- Order ID section -->
              <div class="flex items-center gap-[10px] md:flex-1 w-auto">
                <div
                  class="text-[13px] md:text-[16px] font-semibold text-[#000000] group-hover:text-[#F94D00] whitespace-nowrap overflow-hidden text-ellipsis"
                >
                  {{ OrderNoPrefix }}{{ orderInfo?.value?.id }}
                </div>
              </div>

              <!-- Order Date section -->
              <div
                class="flex items-center gap-[10px] md:flex-1 w-auto justify-center"
              >
                <div
                  class="text-[13px] md:text-[16px] text-[#5B5B5B] whitespace-nowrap overflow-hidden text-center"
                >
                  @if (orderInfo?.value?.order?.order_confirmation_date) {
                    {{
                      StringUtils.getShowDate(
                        orderInfo?.value?.order?.order_confirmation_date
                      )
                    }}
                  } @else {
                    {{
                      StringUtils.getShowDate(
                        orderInfo?.value?.order?.order_booked_date
                      )
                    }}
                  }
                </div>
              </div>

              <!-- Order Total section -->
              <div
                class="flex items-center gap-[10px] md:flex-1 w-auto justify-end"
              >
                <div
                  class="text-[16px] text-[#3BB000] font-medium whitespace-nowrap"
                >
                  {{
                    orderInfo?.value?.order?.total
                      | currency: 'INR' : 'symbol' : '1.0-0'
                  }}
                </div>
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          @for (
            orderItemInfo of orderInfo?.value?.orderItemsInfo;
            track orderItemInfo.orderItem.id
          ) {
            <div
              class="border border-solid !border-x-0 !border-b-0 !last:border-0"
              style="border-top-color: #dfdfdf !important"
            >
              <div class="lg:flex md:gap-[10px] pt-[15px] my-2">
                <div class="flex grow gap-[10px] mr-auto">
                  <div class="flex-shrink-0">
                    <a
                      [href]="
                        orderItemDataMap[orderItemInfo.orderItem?.id]?.pdpUrl
                      "
                      [title]="orderItemInfo.orderItem?.item_title"
                    >
                      @if (orderItemInfo?.product?.imageUrl) {
                        <img
                          [alt]="orderItemInfo.orderItem?.item_title"
                          [title]="orderItemInfo.orderItem?.item_title"
                          [src]="orderItemInfo?.product?.imageUrl"
                          class="object-contain md:h-[100px] md:w-[100px] h-[50px] w-[50px]"
                        />
                      }
                    </a>
                  </div>
                  <div class="grow">
                    <div>
                      <div
                        class="font-semibold text-[#000000] text-[16px] line-clamp-2 mb-[5px]"
                      >
                        {{ orderItemInfo.orderItem?.item_title }}
                      </div>

                      <div class="md:flex md:flex-wrap md:space-x-[10px]">
                        <div class="mr-auto">
                          <div class="text-[#5B5B5B] text-[16px]">
                            Qty: {{ orderItemInfo.orderItem?.quantity }}
                          </div>
                          <div class="text-[#000000] text-[16px]">
                            @if (
                              calculateOrderItemDiscount(
                                orderItemInfo?.orderItem
                              ) > 0
                            ) {
                              Discount: ₹{{
                                calculateOrderItemDiscount(
                                  orderItemInfo?.orderItem
                                )
                              }}
                            }
                          </div>
                          <div class="my-2">
                            <span
                              class="rounded-sm text-[12px]"
                              [attr.style]="
                                getStatusStyle(
                                  orderItemDataMap[orderItemInfo.orderItem?.id]
                                    ?.status
                                )
                              "
                            >
                              {{
                                StringUtils.capitalizeFirstLetter(
                                  orderItemDataMap[orderItemInfo.orderItem?.id]
                                    ?.status
                                )
                              }}
                            </span>
                            @if (
                              orderItemDataMap[orderItemInfo.orderItem?.id]
                                ?.itemStateModified
                            ) {
                              <div class="text-[14px] mt-5">
                                {{
                                  orderItemDataMap[orderItemInfo.orderItem?.id]
                                    ?.itemStateModified
                                }}
                              </div>
                            }
                            @if (
                              orderItemDataMap[orderItemInfo.orderItem?.id]
                                ?.rejectionReason
                            ) {
                              <div class="text-[14px] mt-5">
                                {{
                                  orderItemDataMap[orderItemInfo.orderItem?.id]
                                    ?.rejectionReason
                                }}
                              </div>
                            }
                          </div>
                          @if (
                            orderItemDataMap[
                              orderItemInfo.orderItem?.id
                            ]?.status?.toLowerCase() === 'delivered'
                          ) {
                            @if (
                              orderItemInfo.review?.rating &&
                              orderItemInfo.review?.state === '1'
                            ) {
                              <div class="text-[#3BB000] text-[16px]">
                                {{
                                  orderItemDataMap[orderItemInfo.orderItem.id]
                                    ?.userRatingString
                                }}
                              </div>
                            }
                            @if (
                              orderItemDataMap[orderItemInfo.orderItem.id]
                                ?.actionFlags?.reviewEligible
                            ) {
                              <button
                                (click)="
                                  initiateRating(orderItemInfo?.product?.sku)
                                "
                                class="mt-4 bg-[#162F4D] text-[14px] text-[#ffffff] px-3 py-2 font-semibold rounded-full"
                              >
                                {{
                                  orderItemInfo.review
                                    ? data?.reviewerStaticInfo?.reviewText
                                        ?.reviewViewer?.partiallyCompleted
                                        ?.actionTitle
                                    : data?.reviewerStaticInfo?.reviewText
                                        ?.reviewViewer?.incomplete?.actionTitle
                                }}
                              </button>
                            }
                          } @else if (
                            orderItemDataMap[
                              orderItemInfo.orderItem.id
                            ]?.status?.toLowerCase() !== 'cancelled'
                          ) {
                            <div class="text-[14px]">
                              {{
                                orderItemDataMap[orderItemInfo.orderItem.id]
                                  ?.expectedDeliveryDate
                              }}
                            </div>
                          } @else if (
                            orderItemInfo.orderItem?.requestOrderCancel
                              ?.reasonDoc?.value
                          ) {
                            <div class="text-[#FF0000] text-[12px]">
                              Reason:
                              {{
                                orderItemInfo.orderItem?.requestOrderCancel
                                  ?.reasonDoc?.value
                              }}
                            </div>
                          }
                          @if (
                            orderItemDataMap[orderItemInfo.orderItem.id]
                              ?.returnValidDate
                          ) {
                            <div class="text-[#3BB000] text-[16px]">
                              {{
                                orderItemDataMap[orderItemInfo.orderItem.id]
                                  ?.returnValidDate
                              }}
                            </div>
                          }
                        </div>
                        <div class="flex-shrink mt-auto">
                          <div class="flex flex-col md:w-[300px]">
                            <div class="mb-[5px] md:mt-[5px]">
                              <div
                                class="font-semibold text-[#000000] text-[14px]"
                              >
                                Amount
                                {{
                                  orderItemDataMap[orderItemInfo.orderItem.id]
                                    ?.formattedTotal
                                }}
                              </div>
                              <div class="text-[#5B5B5B] text-[14px]">
                                @if (
                                  orderItemDataMap[orderItemInfo.orderItem.id]
                                    ?.formattedCodCharge
                                ) {
                                  <span>{{
                                    orderItemDataMap[orderItemInfo.orderItem.id]
                                      .formattedCodCharge
                                  }}</span>
                                }
                                @if (
                                  orderItemDataMap[orderItemInfo.orderItem.id]
                                    ?.formattedShippingCharge
                                ) {
                                  <span>{{
                                    orderItemDataMap[orderItemInfo.orderItem.id]
                                      .formattedShippingCharge
                                  }}</span>
                                }
                              </div>
                            </div>
                            <div class="flex gap-[10px] flex-wrap">
                              @if (
                                orderItemDataMap[orderItemInfo.orderItem.id]
                                  ?.actionFlags?.trackable
                              ) {
                                <button
                                  (click)="
                                    openShipmentTracker(
                                      orderItemInfo.orderItem.id
                                    )
                                  "
                                  class="whitespace-nowrap rounded-3xl bg-[#FFFFFF] hover:bg-[#5B5B5B] text-[13px] hover:text-[#FFFFFF] text-[#5B5B5B] cursor-pointer border border-solid font-semibold"
                                  style="
                                    border-color: #dfdfdf !important;
                                    padding: 5px 15px;
                                  "
                                >
                                  {{ data?.orderTitles?.TRACK_ORDER }}
                                </button>
                              }
                              @if (
                                orderItemDataMap[orderItemInfo.orderItem.id]
                                  ?.actionFlags?.returnable
                              ) {
                                <button
                                  class="whitespace-nowrap rounded-3xl bg-[#FFFFFF] hover:bg-[#5B5B5B] text-[13px] hover:text-[#FFFFFF] text-[#5B5B5B] cursor-pointer border border-solid font-semibold"
                                  style="
                                    border-color: #dfdfdf !important;
                                    padding: 5px 15px;
                                  "
                                  (click)="
                                    initiateReturn(orderItemInfo.orderItem.id)
                                  "
                                >
                                  {{ data?.returnTitles?.RAISE_RETURN }}
                                </button>
                              }
                              @if (
                                orderItemDataMap[orderItemInfo.orderItem.id]
                                  ?.actionFlags?.trackReturnable
                              ) {
                                <button
                                  class="whitespace-nowrap rounded-3xl bg-[#FFFFFF] hover:bg-[#5B5B5B] text-[13px] hover:text-[#FFFFFF] text-[#5B5B5B] cursor-pointer border border-solid font-semibold"
                                  style="
                                    border-color: #dfdfdf !important;
                                    padding: 5px 15px;
                                  "
                                  (click)="
                                    openReturnTracker(
                                      orderItemInfo.orderItem.id
                                    )
                                  "
                                >
                                  {{ data?.returnTitles?.TRACK_RETURN_BUTTON }}
                                </button>
                              }
                              @if (
                                orderItemDataMap[orderItemInfo.orderItem.id]
                                  ?.actionFlags?.cancellable
                              ) {
                                <button
                                  mat-button
                                  (click)="
                                    startOrderItemCancellation(
                                      orderItemInfo.orderItem.id
                                    )
                                  "
                                  class="whitespace-nowrap rounded-3xl bg-[#FEEEEE] hover:bg-[#FF0000] text-[13px] hover:text-[#FFFFFF] text-[#FF0000] cursor-pointer border border-solid font-semibold"
                                  style="
                                    border-color: #feeeee !important;
                                    padding: 5px 15px;
                                  "
                                >
                                  {{ data?.orderTitles?.CANCEL_ORDER }}
                                </button>
                              }
                              @if (
                                orderItemDataMap[orderItemInfo.orderItem.id]
                                  ?.invoiceUrl
                              ) {
                                <a
                                  class="whitespace-nowrap rounded-3xl bg-[#FFFFFF] hover:bg-[#5B5B5B] text-[13px] hover:text-[#FFFFFF] text-[#5B5B5B] cursor-pointer border border-solid font-semibold no-underline"
                                  target="_self"
                                  href="{{
                                    orderItemDataMap[
                                      orderItemInfo.orderItem?.id
                                    ].invoiceUrl
                                  }}"
                                  style="
                                    border-color: #dfdfdf !important;
                                    padding: 5px 15px;
                                  "
                                  title="{{
                                    data?.orderTitles?.DOWNLOAD_INVOICE
                                  }}"
                                  >{{ data?.orderTitles?.DOWNLOAD_INVOICE }}</a
                                >
                              }
                              @if (
                                orderItemDataMap[orderItemInfo?.orderItem?.id]
                                  ?.actionFlags?.viewAllPackingImages
                              ) {
                                <div class="flex flex-col items-start">
                                  <button
                                    (click)="
                                      onActionCall(
                                        orderItemDataMap[
                                          orderItemInfo?.orderItem?.id
                                        ]?.viewAllPackingImagesButton?.action
                                      )
                                    "
                                    class="whitespace-nowrap rounded-3xl bg-[#FFFFFF] hover:bg-[#5B5B5B] text-[13px] hover:text-[#FFFFFF] text-[#5B5B5B] cursor-pointer border border-solid font-semibold"
                                    style="
                                      border-color: #dfdfdf !important;
                                      padding: 5px 15px;
                                    "
                                  >
                                    {{
                                      orderItemDataMap[
                                        orderItemInfo?.orderItem?.id
                                      ]?.viewAllPackingImagesButton?.title
                                    }}
                                  </button>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              @if (openedShipmentTrackerId() === orderItemInfo.orderItem.id) {
                <shipment-tracker
                  [data]="
                    orderItemDataMap[orderItemInfo.orderItem.id]
                      .shipmentTrackerData
                  "
                ></shipment-tracker>
              }

              @if (openedReturnTrackerId() === orderItemInfo.orderItem.id) {
                <div
                  class="w-full sticky top-0 grid grid-cols-5 gap-[10px] py-[10px] text-[#162F4D] text-[16px] font-semibold border-b"
                  style="border-bottom-color: #162f4d !important"
                >
                  <div class="">{{ data?.returnTitles?.RETURN_ID }}</div>
                  <div class="">{{ data?.returnTitles?.RETURN_QTY }}</div>
                  <div class="">{{ data?.returnTitles?.RETURN_STATUS }}</div>
                  <div class="">{{ data?.returnTitles?.REFUND_MODE }}</div>
                  <div class=""></div>
                  @for (
                    returnRequest of orderItemInfo?.returnRequestStatusDto
                      ?.returnRequests;
                    track $index
                  ) {
                    <div class="">{{ returnRequest.returnId }}</div>
                    <div class="">{{ returnRequest.returnQuantity }}</div>
                    <div class="">{{ returnRequest.returnStatus }}</div>
                    <div class="">{{ returnRequest.refundMode }}</div>
                    <div class="">
                      @if (returnRequest?.isReturnCancellable) {
                        <button
                          mat-button
                          (click)="
                            returnCancelDialog(
                              data?.returnCancellationDialog,
                              returnRequest.returnId
                            )
                          "
                          class="whitespace-nowrap rounded-3xl bg-[#FEEEEE] hover:bg-[#FF0000] text-[13px] hover:text-[#FFFFFF] text-[#FF0000] cursor-pointer border border-solid font-semibold"
                          style="
                            border-color: #feeeee !important;
                            padding: 5px 15px;
                          "
                        >
                          {{ data?.returnTitles?.RETURN_CANCEL_BUTTON }}
                        </button>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>
